<template>
  <div class="article-page">
    <v-container>
      <!-- Capçalera de l'article -->
      <header class="article-header mb-8">
        <h1 class="text-h3 mb-4">{{ article.title }}</h1>
        <p class="text-subtitle-1 grey--text">{{ article.description }}</p>
        
        <!-- Imatge destacada -->
        <v-img
          v-if="article.featured_image"
          :src="article.featured_image"
          max-height="400"
          contain
          class="my-4"
        ></v-img>
        
        <!-- Categories -->
        <div class="categories mb-4">
          <v-chip
            v-for="category in article.categories"
            :key="category"
            class="mr-2"
            small
          >
            {{ category }}
          </v-chip>
        </div>
      </header>
      
      <!-- Contingut de l'article -->
      <article class="article-content" v-html="article.content"></article>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'ArticlePage',
  data() {
    return {
      article: {
        title: '',
        description: '',
        content: '',
        categories: [],
        featured_image: null
      }
    }
  },
  async mounted() {
    await this.loadArticle()
  },
  methods: {
    async loadArticle() {
      try {
        const path = this.$route.params.article_path
        const { data } = await this.axios.get(`/blog-articles/article/${path}`)
        this.article = data
      } catch (error) {
        console.error('Error carregant article:', error)
      }
    }
  }
}
</script>

<style scoped>
.article-page {
  background: white;
  padding: 2rem 0;
}

.article-content {
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
}

.article-content :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 1rem 0;
}

.article-content :deep(h1),
.article-content :deep(h2),
.article-content :deep(h3) {
  margin: 1.5rem 0 1rem;
  color: #333;
}

.article-content :deep(p) {
  margin-bottom: 1rem;
  color: #444;
}

.article-content :deep(ul),
.article-content :deep(ol) {
  margin: 1rem 0;
  padding-left: 2rem;
}

.article-content :deep(blockquote) {
  margin: 1rem 0;
  padding: 1rem;
  border-left: 4px solid #ddd;
  background: #f9f9f9;
  font-style: italic;
}
</style>
